/** Tracking key for the current main landing experience. */
export const MAIN_LANDING_KEY = 'landing-20260327' as const

/** Identifier for the shipped main landing experience. */
export const MAIN_LANDING_NAME = 'banner_gender_v1' as const

/** Tracking properties merged into funnel events for landing attribution. */
export function getMainLandingTrackingProps(): {
  landing_experiment_key: string
  landing_experiment_variant: string
} {
  return {
    landing_experiment_key: MAIN_LANDING_KEY,
    landing_experiment_variant: MAIN_LANDING_NAME,
  }
}
